module.exports = __webpack_public_path__ + "img/arrow.6763a5b4.svg";